import type { ListProps } from "react-admin";
import { List, Datagrid, TextField, SelectInput, EditButton, FunctionField } from "react-admin";
import { EMPLOYEE_TYPE } from "@/constants";
import { StaffPayrollSetupIncompleteBanner } from "@/containers/staff/shared/StaffPayrollSetupIncompleteBanner";

import { StaffActiveStatusChip } from "./components/StaffActiveStatusChip";
import { STAFF_ACTIVE_FILTER_CHOICES, STAFF_LIST_DEFAULT_FILTERS } from "./staff-active-helpers";

const StaffList = (props: ListProps) => {
  const RegistrationFilters = [
    <SelectInput
      label="Type"
      source="type"
      key="type"
      choices={Object.entries(EMPLOYEE_TYPE).map(([id, name]) => ({ id, name }))}
      sx={{ marginBottom: 0 }}
      alwaysOn
    />,
    <SelectInput
      label="Active"
      source="isActive"
      key="isActive"
      choices={[...STAFF_ACTIVE_FILTER_CHOICES]}
      sx={{ marginBottom: 0 }}
      alwaysOn
    />,
  ];
  return (
    <List {...props} filters={RegistrationFilters} filterDefaultValues={STAFF_LIST_DEFAULT_FILTERS}>
      <StaffPayrollSetupIncompleteBanner />
      <Datagrid rowClick="show">
        <TextField source="id" />
        <TextField source="type" />
        <TextField source="name" />
        <TextField source="phone" />
        <FunctionField
          label="Status"
          source="isActive"
          render={(record: { isActive?: boolean }) => (
            <StaffActiveStatusChip isActive={record?.isActive} />
          )}
        />
        <EditButton />
      </Datagrid>
    </List>
  );
};

export default StaffList;
